const VERSION = "@turnkey/http@2.14.1";

export { VERSION };
//# sourceMappingURL=version.mjs.map
